import { ENABLE_SEPARATE_MEZO_CHAINS, IS_MEZO_MAINNET } from "../constants"

const getMezoNetworkLabel = () => {
  if (ENABLE_SEPARATE_MEZO_CHAINS) {
    return IS_MEZO_MAINNET ? "" : "testnet"
  }

  return "matsnet"
}

const getMezoDAppLabel = () => {
  if (ENABLE_SEPARATE_MEZO_CHAINS) {
    return IS_MEZO_MAINNET ? "Mezo" : "Mezo testnet"
  }

  return "matsnet"
}

export default {
  getMezoDAppLabel,
  getMezoNetworkLabel,
}
